module.exports = __webpack_public_path__ + "static/media/notes-arrow.b17a7404.svg";